// Auth0's nickname, copied over by the Clerk migration. It is the name the account pages showed
// before the switch, so it is shown ahead of firstName until the Settings revamp. Saving a name in
// Settings clears it. Delete this and its callers with that revamp.
export const getLegacyName = (user: { publicMetadata: Record<string, unknown> }) =>
  user.publicMetadata.legacy_name as string | undefined;
